import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Eye } from 'lucide-react';

const PropertyTable = ({ properties, onSelectProperty, onRefresh }) => {
  const { userProfile } = useAuth();
  const getMarketBadge = (marketStatus) => {
    if (marketStatus === 'below_market') {
      return <Badge className="bg-emerald-100 text-emerald-700 border-0">Below Market</Badge>;
    }
    if (marketStatus === 'above_market') {
      return <Badge className="bg-red-100 text-red-700 border-0">Above Market</Badge>;
    }
    return null;
  };

  return (
    <div data-testid="property-table">

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-slate-200 text-left">
              <th className="pb-3 pr-4 text-xs font-semibold text-slate-500 uppercase tracking-wide">Property</th>
              <th className="pb-3 pr-4 text-xs font-semibold text-slate-500 uppercase tracking-wide">Location</th>
              <th className="pb-3 pr-4 text-xs font-semibold text-slate-500 uppercase tracking-wide">Type / Size</th>
              <th className="pb-3 pr-4 text-xs font-semibold text-slate-500 uppercase tracking-wide">Price</th>
              <th className="pb-3 pr-4 text-xs font-semibold text-slate-500 uppercase tracking-wide">Listing</th>
              <th className="pb-3 pr-4 text-xs font-semibold text-slate-500 uppercase tracking-wide">Actions</th>
            </tr>
          </thead>
          <tbody>
            {properties.map((property) => (
              <tr 
                key={property.id} 
                className="border-b border-slate-100 hover:bg-slate-50"
                data-testid={`property-row-${property.id}`}
              >
                <td className="py-4 pr-4">
                  <div className="flex flex-col">
                    <span className="text-sm font-medium text-slate-900 truncate max-w-[180px]">{property.property_title || `Property #${property.id}`}</span>
                  </div>
                </td>
                <td className="py-4 pr-4 text-sm text-slate-700">
                  {[property.district || property.area, property.city].filter(Boolean).join(', ') || '-'}
                </td>
                <td className="py-4 pr-4 text-sm text-slate-700">
                  {[property.property_type, property.bhk, property.area_sqft ? `${property.area_sqft} sqft` : property.land_size ? `${property.land_size} ${property.land_unit || ''}` : ''].filter(Boolean).join(' · ') || '-'}
                </td>
                <td className="py-4 pr-4 text-sm font-semibold text-slate-900">
                  ₹{Number(property.price || property.total_price || 0).toLocaleString('en-IN')}
                </td>
                <td className="py-4 pr-4 text-sm text-slate-700 uppercase font-medium">
                  {property.listing_type || 'sell'}
                </td>
                <td className="py-4 pr-4">
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={() => onSelectProperty(property)}
                    data-testid={`view-property-${property.id}`}
                  >
                    <Eye className="w-4 h-4" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {properties.length === 0 && (
        <div className="text-center py-12 text-slate-500">
          No properties found
        </div>
      )}
    </div>
  );
};

export default PropertyTable;
